import _ from 'lodash';
import util from 'server/js/util';

module.exports = {
	'api/asyncTasks/checkStatus': { method: 'GET' },

	'api/dmsLk/addContractFileForPrograms': { method: 'POST' },
	'api/dmsLk/addDmsContractAttachment': { method: 'POST' },
	'api/dmsLk/addDmsQuestion': { method: 'POST' },
	'api/dmsLk/addProgramsFiles': { method: 'POST' },
	'api/dmsLk/adminData': { method: 'GET' },
	'api/dmsLk/clientData': { method: 'GET' },
	'api/dmsLk/getDmsContract': { method: 'GET' },
	'api/dmsLk/getDmsContractAttachments': { method: 'GET' },
	'api/dmsLk/getDmsContracts': { method: 'GET' },
	'api/dmsLk/getDmsLpu': { method: 'GET' },
	'api/dmsLk/getDmsPolicies': { method: 'GET' },
	'api/dmsLk/getDmsPolicy': { method: 'GET' },
	'api/dmsLk/getDmsQuestions': { method: 'GET' },
	'api/dmsLk/getFilesAndPrograms': { method: 'GET' },
	'api/dmsLk/getInsuredList': { method: 'GET' },
	'api/dmsLk/registerAnswer': { method: 'POST' },
	'api/dmsLk/removeContractFileForPrograms': { method: 'POST' },
	'api/dmsLk/removeDmsContractAttachment': { method: 'POST' },
	'api/dmsLk/removeProgramsFiles': { method: 'POST' },
	'api/dmsLk/sendDmsPolicyOnEmail': { method: 'POST' },
	'api/dmsLk/uploadDmsInsuredPeople': { method: 'POST' },
	'api/dmsLk/uploadDmsLpu': { method: 'POST' },

	'api/eosago/beginFindServiceStations': { method: 'POST' },
	'api/eosago/beginInsurerRsaCheck': { method: 'POST' },
	'api/eosago/beginRsaCheck': { method: 'POST' },
	'api/eosago/checkTi': { method: 'POST' },
	'api/eosago/endFindServiceStations': { method: 'GET' },
	'api/eosago/endInsurerRsaCheck': { method: 'GET' },
	'api/eosago/endRsaCheck': { method: 'GET' },
	'api/eosago/getPolicyForChanging': { method: 'GET' },
	'api/eosago/PossibilityOfChangingPolicy': { method: 'GET' },
	'api/eosago/saveSplunkLog': { method: 'POST' },
	'api/eosago/sendScansToChecking': { method: 'POST' },
	'api/eosago/getUfoScanCheckingStatus': { method: 'GET' },

	'api/kasko3/calculateCase': { method: 'POST' },

	'api/lk/addOsagoPolicy': { method: 'POST' },
	'api/lk/asyncRsaCheck': function (fetch, server) {
		return util.method.async({
			begin: (...a) => server.my.api.lk.beginRsaCheck(...a),
			afterBegin: (response, check) => {
				if (_.get(response, 'responseJSON.Status') === 'Fail') {
					return check.reject(util.error('RsaBeginCheckFailed', { response }));
				}
				if (!_.get(response, 'responseJSON.Success')) {
					return check.reject(util.error('Success: false', { response }));
				}
				if (_.get(response, 'responseJSON.RsaRequestStatus') === 'KeySent') {
					return check.reject(util.error('EsaCheckKeySent', { response }));
				}
				return check.continue(_.pick(response.responseJSON, 'RsaRequestId'));
			},
			check: (...a) => server.my.api.lk.checkRsaRequestStatus(...a),
			afterCheck: (response, check) => {
				if (_.get(response, 'responseJSON.Status') === 'Success') {
					return check.resolve(response);
				}
				if (_.get(response, 'responseJSON.Status') === 'Fail') {
					return check.reject(util.error('RsaCheckFailed', { response }));
				}
				return check.continue();
			},
			interval: 10 * 1000,
		});
	},
	'api/lk/cancelJuridicalPersonConfirmationApplicationSignatureChecking': { method: 'POST' },
	'api/lk/changePassword': {
		method: 'POST',
		_afterAjax: function (promise) {
			return promise.then(util.filter.successStatus);
		}
	},
	'api/lk/checkJuridicalPersonConfirmationApplicationSignature': { method: 'POST' },
	'api/lk/createJuridicalPersonConfirmationApplication': { method: 'POST' },
	'api/lk/getJuridicalPersonConfirmationApplication': { method: 'GET' },
	'api/lk/getOrders': { method: 'GET' },
	'api/lk/getOrder': { method: 'GET' },
	'api/lk/getOrdersToBePaid': { method: 'GET' },
	'api/lk/getQuotationsForProlongation': { method: 'GET' },
	'api/lk/getRegistryOrders': { method: 'GET' },
	'api/lk/orderBso': { method: 'POST' },
	'api/lk/saveSplunkLog': { method: 'POST' },
	'api/lk/uploadCheck': { method: 'POST' },
	'api/lk/uploadJuridicalPersonConfirmationApplicationSignature': { method: 'POST' },
	'api/lk/isExistsUserProfile': { method: 'GET' },
	'api/lk/authorize': { method: 'POST' },

	'api/mite/calculateCase': { method: 'POST' },
	'api/mite/getCase': { method: 'GET' },

	'api/osago/attachProlongationContractToLk': { method: 'POST' },
	'api/osago/calculateCase': { method: 'POST' },
	'api/osago/createOrder': { method: 'POST' },
	'api/osago/finalCalculateCase': { method: 'POST' },
	'api/osago/getCase': { method: 'GET' },
	'api/osago/getPreviousPolicy': { method: 'GET' },

	'api/travel3/calculateCase': { method: 'POST' },
	'api/travel3/getCase': { method: 'GET' },
	'api/travel3ForUSA/calculateCase': { method: 'POST' },

	'cmsapi/lk/esia/authStatus/clear': { method: 'POST' },
	'cmsapi/lk/esia/authStatus/get': { method: 'GET' },

	'cmsapi/lk/getUserProfileSummary': { method: 'GET' },
	'cmsapi/lk/logout': { method: 'POST' },
	'cmsapi/lk/updateUserProfileSummary': { method: 'POST' },
	'cmsapi/lk/createComplaint': { method: 'POST' },

	'api/registerClaim/registerClaim': { method: 'POST' },
};

